module.exports = __webpack_public_path__ + "static/shopify_google-pay-cc95d017e877f3b8efd4cb1d70781f7f.svg";